// Theme subpages mapping — kept in sync with /app/scripts/generate_theme_pages.py.
// Used by Header (themes dropdown) and Landing (themes grid) to link to
// the SEO-friendly subpages instead of in-app theme switching.

export const THEME_PAGES = [
  {
    id: "sinterklaas",
    emoji: "🎁",
    color: "#C8102E",
    bg: "#FFF5F0",
    labelI18n: { nl: "Sinterklaas", en: "Sinterklaas", de: "Sinterklaas" },
    slugI18n: { nl: "sinterklaas", en: "sinterklaas", de: "sinterklaas" },
  },
  {
    id: "kerst",
    emoji: "🎄",
    color: "#0E5C2F",
    bg: "#F2F8F2",
    labelI18n: { nl: "Kerstbingo", en: "Christmas", de: "Weihnachten" },
    slugI18n: { nl: "kerstbingo", en: "christmas-bingo", de: "weihnachtsbingo" },
  },
  {
    id: "pasen",
    emoji: "🐰",
    color: "#F5A623",
    bg: "#FFF9E8",
    labelI18n: { nl: "Pasen", en: "Easter", de: "Ostern" },
    slugI18n: { nl: "paasbingo", en: "easter-bingo", de: "osterbingo" },
  },
  {
    id: "halloween",
    emoji: "🎃",
    color: "#1a1a1a",
    bg: "#FFF3E0",
    labelI18n: { nl: "Halloween", en: "Halloween", de: "Halloween" },
    slugI18n: { nl: "halloween-bingo", en: "halloween-bingo", de: "halloween-bingo" },
  },
  {
    id: "valentijn",
    emoji: "❤️",
    color: "#E91E63",
    bg: "#FCE4EC",
    labelI18n: { nl: "Valentijn", en: "Valentine's", de: "Valentinstag" },
    slugI18n: { nl: "valentijnsbingo", en: "valentine-bingo", de: "valentinsbingo" },
  },
  {
    id: "verjaardag",
    emoji: "🎂",
    color: "#FF4081",
    bg: "#FFF1F5",
    labelI18n: { nl: "Verjaardag", en: "Birthday", de: "Geburtstag" },
    slugI18n: { nl: "verjaardagsbingo", en: "birthday-bingo", de: "geburtstagsbingo" },
  },
  {
    id: "bruiloft",
    emoji: "💍",
    color: "#9C7B3B",
    bg: "#FFF8F0",
    labelI18n: { nl: "Bruiloft", en: "Wedding", de: "Hochzeit" },
    slugI18n: { nl: "bruiloftsbingo", en: "wedding-bingo", de: "hochzeitsbingo" },
  },
  {
    id: "zomer",
    emoji: "🏖️",
    color: "#03A9F4",
    bg: "#E1F5FE",
    labelI18n: { nl: "Zomer & Strand", en: "Summer & Beach", de: "Sommer & Strand" },
    slugI18n: { nl: "zomerbingo", en: "summer-bingo", de: "sommer-bingo" },
  },
  {
    id: "winter",
    emoji: "❄️",
    color: "#3F51B5",
    bg: "#E8EAF6",
    labelI18n: { nl: "Winter", en: "Winter", de: "Winter" },
    slugI18n: { nl: "winterbingo", en: "winter-bingo", de: "winterbingo" },
  },
  {
    id: "sport",
    emoji: "⚽",
    color: "#0E5C2F",
    bg: "#F1F8E9",
    labelI18n: { nl: "Sport", en: "Sports", de: "Sport" },
    slugI18n: { nl: "sportbingo", en: "sports-bingo", de: "sport-bingo" },
  },
  {
    id: "natuur",
    emoji: "🌳",
    color: "#558B2F",
    bg: "#F1F8E9",
    labelI18n: { nl: "Natuur", en: "Nature", de: "Natur" },
    slugI18n: { nl: "natuurbingo", en: "nature-bingo", de: "natur-bingo" },
  },
  {
    id: "reizen",
    emoji: "✈️",
    color: "#1565C0",
    bg: "#E3F2FD",
    labelI18n: { nl: "Reizen", en: "Travel", de: "Reisen" },
    slugI18n: { nl: "reisbingo", en: "travel-bingo", de: "reise-bingo" },
  },
  {
    id: "bedrijfsfeest",
    emoji: "🏢",
    color: "#283593",
    bg: "#E8EAF6",
    labelI18n: { nl: "Bedrijfsfeest", en: "Office Party", de: "Firmenfeier" },
    slugI18n: { nl: "bedrijfsfeestbingo", en: "office-party-bingo", de: "firmenfeier-bingo" },
  },
  {
    id: "wk",
    emoji: "🏆",
    color: "#C8102E",
    bg: "#EAF4EA",
    labelI18n: { nl: "WK Voetbal", en: "World Cup", de: "WM Fußball" },
    slugI18n: { nl: "wk-bingo", en: "world-cup-bingo", de: "wm-bingo" },
  },
];

export function themePageUrl(theme, lang) {
  const slug = theme.slugI18n[lang] || theme.slugI18n.en;
  return `/${lang}/${slug}/`;
}
